import Logo from 'assets/images/logo.png';
import Hamburger from 'assets/svgs/Hamburger';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import MobileNav from './MobileNav';
import './styles.css';

const Navbar = () => {
    const [showSideNav , setShowSideNav] = useState(false);


    return (
        <div>
            <nav className='lg-nav flex items-center justify-between lg:px-20 md:px-12 sm:px-8 px-4 py-4'>
                <div>
                    <img 
                    src={Logo} 
                    alt="Logo" 
                    className='md:w-full sm:w-[120px] w-[100px]'
                    />
                </div>
                <ul className='lg-nav-list flex items-center gap-8 text-secondary'>
                    <li className='hover:text-secondaryLight'>
                        <Link to='/'>Home</Link>
                    </li>
                    <li className='hover:text-secondaryLight lg:block hidden'>
                        <Link to='/'>How It Works</Link>
                    </li>
                    <li className='hover:text-secondaryLight'>
                        <Link to='/inventory'>Inventory</Link>
                    </li>
                    <li className='hover:text-secondaryLight'>
                        <Link to='/'>About Us</Link>
                    </li>
                    <li className='hover:text-secondaryLight'>
                        <Link to='/'>Contact</Link>
                    </li>
                </ul>
                <div className='lg-nav-auth-btns flex items-center gap-6 uppercase'>
                    <Link to='/user/dashboard' className='text-black font-medium'>
                        LOGIN
                    </Link>
                    <Link to='/register'>
                        <button className="btn-primary py-1">register</button>
                    </Link>
                </div>
                <div className='lg-nav-hamburger cursor-pointer'
                onClick={(e) => {
                    e.stopPropagation();
                    setShowSideNav(prev => !prev)
                }}
                >
                    <Hamburger />
                </div>
            </nav>
            <div>
                {
                    showSideNav && <div className='absolute top-0 left-0 bg-[#0000007e] w-full h-screen'></div>
                }
                <MobileNav 
                showSideNav={showSideNav} 
                setShowSideNav={setShowSideNav} 
                />
            </div>
        </div>
    )
}

export default Navbar